import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── 15.8 Povești care curg ── */
export function HomeStoriesBand() {
  const c = useSectionContent("home_stories");
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/stories?limit=8").then((r) => setItems(r.data.items || [])).catch(() => {}); }, []);
  if (items.length === 0) return null;
  return (
    <section className="py-16 lg:py-20" style={{ background: "var(--ct-surface)" }}>
      <div className="max-w-5xl mx-auto px-5">
        <div className="text-center mb-10">
          <span data-el="eyebrow" className="eyebrow inline-flex items-center gap-1.5"><BookOpen size={13} /> <span data-field="eyebrow">{c.eyebrow || "Oameni ca tine"}</span></span>
          <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mt-3">{c.title || "Au trecut pe aici înaintea ta"}</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.slice(0, 6).map((s) => (
            <div key={s.id} className="card-premium p-6">
              <h3 data-el="item_title" className="font-serif text-lg mb-2">„{s.title}"</h3>
              <p data-el="item_body" className="text-sm line-clamp-4" style={{ color: "var(--ct-text-muted)" }}>{s.text}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-8"><Link data-el="cta" data-field="cta" to="/povesti" className="btn-ghost text-sm">{c.cta || "Citește toate poveștile"} <ArrowRight size={14} /></Link></div>
      </div>
    </section>
  );
}
